import dayjs from "dayjs";
import { useFormikContext } from "formik";
import { TextAreaField, VerticalForm } from "melco-shared-logic";
import { Button, DatePicker, FormItem, Space, StopIcon } from "melco-ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const Right = styled(Space)`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const SerialNumberItem = styled.div`
  margin: 11px 0px;

  span {
    font-weight: 800;
  }
`;

type DisplayCancelLicenseFormProps = {
  licenseSerialNumberToCancel: string;
};

export const DisplayCancelLicenseForm: React.FC<
  DisplayCancelLicenseFormProps
> = ({ licenseSerialNumberToCancel }) => {
  const { t } = useTranslation();
  const { submitForm, setFieldValue } = useFormikContext();
  const [selectedDate, setSelectedDate] = useState<Date>(dayjs().toDate()); // Default to today
  return (
    <>
      <div>
        <Right direction="vertical" size="small">
          {/* <Space size="small"> */}
          <Button
            icon={<StopIcon />}
            type="primary"
            onClick={() => {
              submitForm();
            }}
          >
            {t("licenses.basic.detail.cancel.button")}
          </Button>
          {/* </Space> */}
        </Right>

        <VerticalForm>
          <SerialNumberItem>
            {" "}
            {t("licenses.basic.detail.generate.serial_number.title")} :{" "}
            <span> {licenseSerialNumberToCancel} </span>{" "}
          </SerialNumberItem>
          <FormItem
            label={t("licenses.basic.detail.cancel.cancelled_date")}
            //label={"Cancelled date"}
            name="subCancelledDate"
          >
            <DatePicker
              format="L"
              className="full-width-dropdown"
              disabledDate={(current) =>
                !!current && current.isBefore(dayjs().startOf("day"))
              }
              //   name="subCancelledDate"
              onChange={(v) => {
                const datetime: Date | undefined =
                  (v && v.startOf("day").toDate()) ?? undefined;
                if (datetime) {
                  setSelectedDate(datetime);
                  setFieldValue("subCancelledDate", datetime);
                }
              }}
              style={{ width: "100%" }} //  Full width
              value={dayjs(selectedDate)}
            />
          </FormItem>
          <TextAreaField
            name="CancellationReason"
            label={t("licenses.basic.detail.cancel.reason")}
            showCount
            maxLength={1000}
            rows={9}
          />
        </VerticalForm>
      </div>
    </>
  );
};
